import React from 'react';
import { useAppSelector } from 'store/hooks';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { PrimaryAccountsPage } from './containers';
import { selectSpaceInfo } from './reducers/selectors';
const PrimarySpaceAccounts = withAnimatedNavigationHeader(({ route, onScroll }) => {
    const space = route.params?.space;
    const spaceInfo = useAppSelector(selectSpaceInfo);
    return (<PrimaryAccountsPage spaceInfo={spaceInfo[space.id]} onScroll={onScroll}/>);
}, ({ colors }) => ({
    title: 'Space settings',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default PrimarySpaceAccounts;
